<div class="modal">
  <div class="modal-header modal-header--black-background" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <div class="title">Обновление данных</div>
    <div class="close" (click)="close()">
      <i class="icon-plus"></i>
    </div>
  </div>

  <div class="modal-body modal-body--padding22" *ngIf="data?.errorStatus === 1">
    <div class="main-text font--bold">
      Внимание!
    </div>
    <div class="main-text">
      Сервис РГП “Госэкспертиза” <br> не вернул данные
    </div>

    <div class="sub-text text--orange">
      {{ data?.errorText }}
    </div>
    <div class="sub-text">
      Проверьте на корректность введенные данные
    </div>
    <div class="btns">
      <div class="btn btn-apply btn--250px btn--upload-file" (click)="attach()"> Прикрепить файлы вручную </div>
    </div>
  </div>

  <div class="modal-body modal-body--padding22" *ngIf="data?.errorStatus === 0">
    <div class="main-text">
      Сервис РГП “Госэкспертиза” <br> вернул данные
    </div>

    <div class="main-text font--bold text--red">
      Внимание!
    </div>
    <div class="sub-text">
      Подтвердите, что это один и тот же объект
    </div>
    <div class="objects">
      <div class="object-item">
        <div class="object-item__title">Ваш объект:</div>
        <div class="object-item__name text--black">
          {{ data?.objectName }}
        </div>
      </div>
      <div class="object-item">
        <div class="object-item__title">Объект РГП “Госэкспертиза”:</div>
        <div class="object-item__name text--blue">
          {{ data?.incomeObjectName }}
        </div>
      </div>
    </div>
  </div>




  <div class="modal-footer modal-footer--border-top">
    <div class="btn btn-apply" (click)="accept()" *ngIf="data?.errorStatus === 0">
      <ng-container *ngIf="loader; else text">
        <div class="loading"></div>
      </ng-container>
      <ng-template #text>Да, верно</ng-template>
    </div>
    <div class="btn btn-cancel" (click)="close()"> Закрыть </div>
  </div>
</div>
